<template>
    <Card class="mb-5 card-border shadow-0 bg-transparent task-row" >
        <div class="card-xl-stretch " >
            <div  class="d-flex align-items-center justify-content-between mb-2 m-5">
                <h3 class="align-items-start flex-column cursor-pointer" @click.prevent="goToDetails">
                    <span class="card-label fw-bolder text-dark">{{ taskData.title }}</span>
                </h3>
              <div class="task-react-action">
                <TaskQuickReact :task-id="taskData.id" @callback="updateReact" />
              </div>
            </div>
            <hr>
            <div class="m-5">
                <div  class="d-flex justify-content-between mb-2 ">
                    <span class="badge badge-white fs-5"> <span class="text-primary me-3">{{taskData?.checkedChecklists + '/'+taskData?.totalChecklists}}</span> {{ $t('projects.label.checklist') }}</span>
                    <div class="d-flex gap-2">
                      <template v-if="Object.keys(taskReactsGrouped).length">
                        <TaskReactResume
                            v-for="(reacts, emoji) in taskReactsGrouped"
                            :emoji="emoji"
                            :task-id="taskData.id"
                            :total="reacts.length"
                            :reacts="reacts"
                            @callback="updateReact"
                        />
                      </template>
                      <div @click.prevent.exact="handleClick" class="d-flex align-items-center cursor-pointer">
                        <div class="text-black fw-light fs-5 me-3">{{ taskComments.length + ' ' + $t('projects.label.comments') }}</div>
                        <i :title="$t('projects.label.addTaskComment')" class="fs-4 fas fa-comment text-primary"></i>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer p-5" v-if="taskData?.history">
            <LastUpdate :id="'task'+id" :history="taskData?.history"/>
        </div>
    </Card>
</template>

<script setup>
    import { computed, defineProps, ref } from "vue";
    import { useStore } from 'vuex'
    import Card from '@/components/Card.vue';
    import "vue3-circle-progress/dist/circle-progress.css";
    import { useRouter } from "vue-router";
    import LastUpdate from "@/Modules/Projects/components/LastUpdate.vue";
    import TaskQuickReact from "@/Modules/Projects/views/Reports/components/TaskQuickReact.vue";
    import TaskReactResume from "@/Modules/Projects/views/Reports/components/TaskReactResume.vue";

    const store = useStore()
    const emit = defineEmits(['callback'])
    const props = defineProps({
        task: {
            type: Object,
            default: {
                id: 1,
                title: "Test",
                progress: "39",
                status_formatted: {
                    color: "red",
                    fr: "En cours"
                }
            }
        },
        handleTaskSelected: {
            type: Function,
            default: () => {}
        },
        
        id: {
            type: [String, Number],
            default: "id"
        },
        project: {
            type: String,
            default: "id"
        }
    })

    const router = useRouter()
    const taskData = ref(props.task)


    const currentUser = computed(() => store.getters['user/currentUser'])
    const taskReacts = computed(() => {
      if (props.task && props.task.comments) {
        return props.task.comments.filter(el => el.type === 'EMOJI') || []
      }
      return []
    })

    const taskReactsGrouped = computed(() => {
      return taskReacts.value.reduce((acc, react) => {
        const key = react.comment
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(react)
        return acc
      }, {})
    })

    const taskComments = computed(() => {
      if (props.task && props.task.comments) {
        return props.task.comments.filter(el => el.type === 'TEXT') || []
      }
      return []
    })



    const handleClick = () => {
        props.handleTaskSelected(props.task)
    }

    const goToDetails = () => {
        router.push({ name: 'tasks-view', params: { id: props.task?.id, project: props.project } })
    }

    const getModelElement = () => {
        let attr = ['title', 'name', 'comment']
        let existKey = attr.find(key => props.task?.history?.model?.[key] !== undefined)
        return props.task?.history?.model[existKey];
    }

    function updateReact(react) {
      const index = taskData.value.comments.findIndex(
          el => el.comment === react.comment && el.user_id === currentUser.value.id
      );

      emit('callback');

      if (index !== -1) {
        taskData.value.comments.splice(index, 1);
      } else {
        taskData.value.comments.push({...react, user_name: react.full_name});
      }
    }

</script>
<style scoped>
.task-row {
}

.task-react-action {
  opacity: 0;
  pointer-events: none;
  transform: translateY(-5px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.task-row:hover .task-react-action {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}
</style>
